var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9356 4.89114L12.9363 4.8918C13.4463 5.40247 13.4669 6.21447 12.9816 6.70114L6.98359 12.6991C6.76692 12.9158 6.47959 13.0498 6.17426 13.0778L3.39426 13.3305C3.37426 13.3325 3.35426 13.3331 3.33359 13.3331C3.15826 13.3331 2.98826 13.2638 2.86226 13.1378C2.72226 12.9978 2.65226 12.8031 2.66959 12.6065L2.92226 9.82647C2.95026 9.5218 3.08492 9.2338 3.30226 9.01714L9.29959 3.0198C9.76759 2.5498 10.6163 2.57314 11.1103 3.0658L12.9356 4.89114ZM10.6794 7.11912L8.88269 5.32246L10.1814 4.02312L11.9774 5.81912L10.6794 7.11912ZM6.05312 11.7498L4.06845 11.9305L4.24445 9.95982L7.98912 6.21515L9.78645 8.01248L6.05312 11.7498Z",
    fill: "#3E354A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3177_73891",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9356 4.89114L12.9363 4.8918C13.4463 5.40247 13.4669 6.21447 12.9816 6.70114L6.98359 12.6991C6.76692 12.9158 6.47959 13.0498 6.17426 13.0778L3.39426 13.3305C3.37426 13.3325 3.35426 13.3331 3.33359 13.3331C3.15826 13.3331 2.98826 13.2638 2.86226 13.1378C2.72226 12.9978 2.65226 12.8031 2.66959 12.6065L2.92226 9.82647C2.95026 9.5218 3.08492 9.2338 3.30226 9.01714L9.29959 3.0198C9.76759 2.5498 10.6163 2.57314 11.1103 3.0658L12.9356 4.89114ZM10.6794 7.11912L8.88269 5.32246L10.1814 4.02312L11.9774 5.81912L10.6794 7.11912ZM6.05312 11.7498L4.06845 11.9305L4.24445 9.95982L7.98912 6.21515L9.78645 8.01248L6.05312 11.7498Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3177_73891)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOutline);
export default __webpack_public_path__ + "static/media/edit-outline.10065b353f6e2f3cf03939341264639c.svg";
export { ForwardRef as ReactComponent };